/*
 *
 * Copyright (c) Vaisala Oyj. All rights reserved.
 *
 */

import { useTranslation } from 'react-i18next';

export function useChangeLanguage() {
  const { i18n } = useTranslation();
  const en = () => i18n.changeLanguage('en');
  const fi = () => i18n.changeLanguage('fi');
  return { en, fi, current: i18n.language };
}
